<template>
    <div id="learning-project">
        <el-tabs type="border-card">
            <el-tab-pane v-for="(i, index) in item" :key="index" :label="i.name">
                <ProjectItem :item="i" />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import ProjectItem from './ProjectItem.vue';
export default {
    name: "LearningProject",
    components: { ProjectItem },
    data() {
        return {
            item: [
                {
                    name: 'myWeb',
                    type: 'Self-learning',
                    period: 'Jul 2022 - Aug 2022',
                    description: [
                        'Built a personal website using the JavaScript framework Vue.js and tools like Vuex and Vue-router',
                    ],
                    resources: 'https://github.com/DonaldLamNL/myWeb/tree/main',
                    link: 'https://donaldlamnl.github.io/myWeb/#/home',
                },
                {
                    name: 'myBlog',
                    content: [
                        {title: 'Type', content: 'Self-Learning'},
                        {title: 'Time', content: 'Aug 2022'},
                        {title: 'Description', content: ''},
                        // {title: 'Elements', content: [
                        // ]}
                    ],
                    resources: '',
                    link: '',
                },
                {
                    name: 'Smart Cam',
                    content: [
                        {title: 'Type', content: 'CSCI3250 Computers and Society'},
                        {title: 'Time', content: '2022 Spring Semester'},
                        {title: 'Description', content: ''},
                        // {title: 'Elements', content: [
                        // ]}
                    ],
                    resources: '',
                    link: '',
                },
            ]
        };
    },
}
</script>

<style scoped>
.el-tabs{
    margin: 20px auto;
    width: 1100px;
    height: 500px;
    overflow: scroll;
}
.el-tab-pane{
    padding: 0 30px;
}
</style>